export type ReplaySessionState =
  | "live"
  | "loading"
  | "ready"
  | "playing"
  | "paused"
  | "ended"
  | "error";

export const TRANSITIONS: Record<ReplaySessionState, ReplaySessionState[]> = {
  live: ["loading"],
  loading: ["ready", "error", "live"],
  ready: ["playing", "paused", "live"],
  playing: ["paused", "ended", "error"],
  paused: ["playing", "live"],
  ended: ["playing", "paused", "loading", "live"],
  error: ["loading", "live"],
};

export interface ReplayTransitionSuccess {
  ok: true;
  state: ReplaySessionState;
}

export interface ReplayTransitionFailure {
  ok: false;
  error: string;
}

export type ReplayTransitionResult =
  | ReplayTransitionSuccess
  | ReplayTransitionFailure;

export function canTransition(
  from: ReplaySessionState,
  to: ReplaySessionState,
): boolean {
  return TRANSITIONS[from]?.includes(to) ?? false;
}

export function getTransitionError(
  from: ReplaySessionState,
  to: ReplaySessionState,
): string | null {
  if (canTransition(from, to)) {
    return null;
  }

  return `Invalid replay transition: ${from} -> ${to}`;
}

export function transition(
  currentState: ReplaySessionState,
  targetState: ReplaySessionState,
): ReplayTransitionResult {
  const error = getTransitionError(currentState, targetState);
  if (error) {
    return { ok: false, error };
  }

  return {
    ok: true,
    state: targetState,
  };
}
